<template>
  <div class="fill-height">
    <template v-if="isLoading">
      <v-container class="fill-height">
        <v-row
          align="center"
          justify="center"
        >
          <v-progress-circular
            :size="80"
            color="accent"
            :width="8"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <documents-toolbar
        @onRefresh="loadData"
      />
      <v-container style="padding-top: 56px;">
        <v-row v-for="(documents, storeId) in filteredRecords" :key="storeId" dense>
          <v-col v-if="documents.length">
            <p class="title mb-0 mt-4"><v-icon color="primary" class="mb-1">mdi-inbox-multiple</v-icon>{{_getStoreName(storeId)}}</p>
          </v-col>
          <v-col
            v-for="(document, i) in documents"
            :key="i"
            :class="{'pt-0' : i === 0}"
            cols="12">
            <v-card
              tile
            >
              <v-card-text class="pa-2">
                <div class="d-flex flex-no-wrap justify-space-between">
                  <div class="subtitle-2 grey--text text--darken-2">
                    {{document.doc_id}}
                    <v-icon color="accent" small v-if="document.products">mdi-laptop</v-icon>
                  </div>
                  <div class="caption grey--text">{{document.created_on}}</div>
                </div>
                <div class="grey--text text--darken-1 font-weight-medium body-2">{{document.kontragenti_name}}</div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  color="primary"
                  @click="openDocument(document)"
                >
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <document
        ref="document"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import documentsToolbar from './documentsToolbar'
import ShipmentApi from '../api'
import { mapValues } from 'lodash'
import document from 'app/document/components/document'

export default {
  name: 'shipmentDocuments',
  components: {
    documentsToolbar,
    document
  },
  data () {
    return {
      isLoading: false,
      records: {}
    }
  },
  computed: {
    ...mapGetters('shipment', {
      _getStoreName: 'getStoreName'
    }),
    ...mapMultiRowFields('shipment', {
      _stores: 'stores'
    }),
    ...mapFields('shipment', {
      _searchTerm: 'searchTerm'
    }),
    filteredRecords () {
      let selectedStores = this._stores.filter(record => record.selected).map(record => record.id)
      let filteredByStore = Object.keys(this.records)
        .filter(key => selectedStores.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.records[key]
          return obj
        }, {})
      if (this._searchTerm) {
        filteredByStore = mapValues(filteredByStore, (documents) => {
          return documents.filter((record) => record.doc_id.includes(this._searchTerm) || record.kontragenti_name.includes(this._searchTerm))
        })
      }
      return filteredByStore
    }
  },
  methods: {
    async loadData () {
      this.isLoading = true
      let response = await ShipmentApi.getDocuments()
      this.records = response.data
      let stores = Object.keys(this.records)
      stores.forEach(storeId => {
        this._stores.find(record => record.id === storeId).active = true
      })
      this.isLoading = false
    },
    openDocument (document) {
      this.$refs.document.open(document)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>

</style>
